class MessagingInitDataResultModel {
    constructor({ type = "", success = false, message = "", chatData = {}, messagesData = [], error = [] } = {}) {
        this._type = type;
        this._success = success;
        this._message = message;
        this._chatData = chatData;
        this._messagesData = messagesData;
        this._error = error;
    }

    get type() {
        return this._type;
    }

    get success() {
        return this._success;
    }

    get message() {
        return this._message;
    }

    get chatData() {
        return this._chatData;
    }

    get messagesData() {
        return this._messagesData;
    }

    get error() {
        return this._error;
    }
}

export default MessagingInitDataResultModel;